module.exports = __webpack_public_path__ + "img/01_christina-wocintechchat.1fd582cd.jpg";